import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { UPLOAD_LIMIT } from "../../Utils/Constants";
const VideoUpload = ({
  onChangeContent,
  showErrorMsg,
  defaultVideo = null,
}) => {
  const [videoFilePath, setVideoFilePath] = useState(null);
  const [videoContent, setVideoContent] = useState(null);
  const videoButton = useRef();

  useEffect(() => {
    if (videoContent) onChangeContent(videoContent);
  }, [videoContent]);

  useEffect(() => {
    setVideoFilePath(defaultVideo);
  }, [defaultVideo]);

  const selectFile = (e) => {
    const fileContent = e.target.files[0];

    // enforce file size limit
    if (fileContent.size > UPLOAD_LIMIT) {
      showErrorMsg && showErrorMsg();
      return;
    }

    setVideoContent(fileContent);
    setVideoFilePath(URL.createObjectURL(fileContent));
  };

  return (
    <React.Fragment>
      <div className="col-12 mb-1">
        <label htmlFor="image">Upload Video: &nbsp;</label>
        <input
          ref={videoButton}
          type="file"
          id="video"
          name="video"
          accept="video/mp4"
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-green"
          onClick={() => videoButton.current.click()}
        >
          Choose Video
        </button>
      </div>
      <div className="col-12">
        <ReactPlayer
          url={videoFilePath}
          width="100%"
          height="100%"
          controls={true}
        />
      </div>
    </React.Fragment>
  );
};
export default VideoUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/VideoUpload.js